import { lazy, Suspense, type FC } from 'react'

import { Spinner } from '@arcotech-services/iris-react'

import {
  RouterProvider,
  Navigate,
  createBrowserRouter,
  type RouteObject
} from 'react-router-dom'

import { ROUTE_PATH } from '@/Common/constants'

import type { AppRouterProps } from './app-router.types'

const AssessmentCreatePage = lazy(
  () => import('@/Modules/Assessment/modules/Create')
)
const AssessmentEditPage = lazy(
  () => import('@/Modules/Assessment/modules/Edit')
)
const AssessmentList = lazy(() => import('@/Modules/Assessment/modules/List'))

const routes: RouteObject[] = [
  {
    path: ROUTE_PATH.ASSESSMENT_LIST,
    element: <AssessmentList />,
    index: true
  },
  { path: ROUTE_PATH.ASSESSMENT_CREATE, element: <AssessmentCreatePage /> },
  { path: ROUTE_PATH.ASSESSMENT_EDIT, element: <AssessmentEditPage /> },
  { path: '*', element: <Navigate to={ROUTE_PATH.ASSESSMENT_LIST} replace /> }
]

const AppRouter: FC<AppRouterProps> = ({ basename }) => {
  const router = createBrowserRouter(routes, { basename })

  return (
    <Suspense fallback={<Spinner />}>
      <RouterProvider router={router} />
    </Suspense>
  )
}

export default AppRouter
